import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import Button from "@edaz/edazkit/Button";
import { Alert, ButtonToolbar } from "react-bootstrap";

import UserDetailViewModel from "viewModels/users/users/userDetailViewModel";
import HeaderWithBackButton from "components/headerWithBackButton";
import Tabs from "views/common/tabs";

const UserDetailView: ViewComponent<UserDetailViewModel> = observer(({ vm }) => {
  if (!vm.itemLoaded) {
    return <LoaderOverlay loading={true} style={{ minHeight: 200 }} />;
  }

  let alert;

  if (vm.invitationExpired) {
    alert = (
      <Alert className="mb-4" variant="danger">
        {vm.translate("invitationExpired")}
      </Alert>
    );
  } else if (!vm.item.isActive) {
    alert = (
      <Alert className="mb-4" variant="warning">
        {vm.translate("noActive")}
      </Alert>
    );
  }

  return (
    <LoaderOverlay loading={vm.busyWatcher.isBusy}>
      {alert}
      <HeaderWithBackButton className="mb-4" title={vm.name} back={{ link: vm.backLink, action: vm.close }} />
      {(vm.invitationExpired || vm.item.invitation) && (
        <ButtonToolbar className="mb-4">
          {(vm.invitationExpired || vm.item.isActive) && vm.allowWrite && (
            <Button className="rounded" variant="secondary" size="sm" onClick={vm.onExtendInvitationClick}>
              {vm.translate("extendInvitationValidity")}
            </Button>
          )}
          {!vm.invitationExpired && (
            <>
              {vm.allowWrite && (
                <Button className="rounded" variant="secondary" size="sm" onClick={vm.onActivationEmailClick}>
                  {vm.translate("sendActivationEmail")}
                </Button>
              )}
              <Button className="rounded" variant="secondary" size="sm" onClick={vm.onCopyActivationEmailClick}>
                {vm.translate("copyActivationLink")}
              </Button>
            </>
          )}
        </ButtonToolbar>
      )}
      <Tabs vm={vm} />
    </LoaderOverlay>
  );
});

registerView(UserDetailView, UserDetailViewModel);
